module.exports = __webpack_public_path__ + "img/SINPEMOVIL.17ac35b0.jpeg";